<template>
  <svg
    width="59"
    height="41"
    viewBox="0 0 59 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 15.625C46.125 7 39 0.625 30 0.625C22.875 0.625 16.875 4.75 13.875 10.75C6.375 11.875 0.75 17.875 0.75 25.75C0.75 34 7.5 40.75 15.375 40.75H46.875C53.625 40.75 58.875 35.125 58.875 28.375C59.25 21.625 54 16 48 15.625ZM34.875 23.125V33.25H25.125V23.125H18L30 10.75L42 23.125H34.875Z"
      fill="#A8A8A8"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Upgrade',
} as DefineComponent
</script>
